import React from 'react';
import { LayoutDashboard, Briefcase, Building2, LifeBuoy } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const ITEMS = [
  { label: 'Home', Icon: LayoutDashboard, path: '/dashboard' },
  { label: 'Workspace', Icon: Briefcase, path: '/workspace' },
  { label: 'Profile', Icon: Building2, path: '/profile' },
  { label: 'Support', Icon: LifeBuoy, path: '/support' },
];

/**
 * Mobile primary navigation tray. Visible only below md; the full nav lives in
 * the hamburger NavDrawer. Targets are ≥ 44px tall for touch.
 */
export function BottomTray() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 flex bg-bw-surface border-t border-bw-border pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary"
    >
      {ITEMS.map(({ label, Icon, path }) => {
        const active = location.pathname === path || location.pathname.startsWith(path + '/');
        return (
          <button
            key={label}
            onClick={() => navigate(path)}
            aria-current={active ? 'page' : undefined}
            className={`flex-1 min-h-[56px] flex flex-col items-center justify-center gap-1 ${
              active ? 'text-bw-primary' : 'text-bw-muted'
            }`}
          >
            <Icon className="h-5 w-5" />
            <span className={`text-[10px] ${active ? 'font-semibold' : 'font-normal'}`}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomTray;
